import { getOrgPermissions } from '../../utils/permissions';
import { isPlatformStaff } from '../../utils/platformRole';

// Who may add or change AML Program data. Mirrors the server's rule for every AML write
// (MarkupsUtils.isOrgManager: org admins, partner roles, platform staff). Everyone else gets the
// screens read-only, instead of buttons that end in "This action requires an administrator role."
export const canManageAml = () => {
  const { isOrgAdmin, isPartner } = getOrgPermissions();
  return isOrgAdmin || isPartner || isPlatformStaff();
};
